import React from 'react';
import { FC } from 'react';

// Interfaces
import { Summary } from '../../../interfaces/Summary';
import { Heading } from '../../Heading';

const SummarySection: FC<Summary> = ({ title, items }) => {
  return (
    <div className="membership-app__summary-section">
      <Heading
        className="membership-app__summary-section-header"
        size={'medium'}
      >
        {title}
      </Heading>
      <div className="membership-app__summary-items">
        {items.map((i) => (
          <div key={i.question} className="membership-app__summary-item">
            <Heading
              className="membership-app__summary-item-question"
              size={'small'}
            >
              {i.question}
            </Heading>
            <div className="membership-app__summary-item-answer-wrapper">
              <div>
                <p className="membership-app__summary-item-answer">
                  {i.answer}
                </p>
                {i.complementaryAnswers && i.complementaryAnswers.length > 0 && (
                  <ul className='membership-app__summary-item-complementary'>
                    {i.complementaryAnswers.map(a => <li key={a}>{a}</li>)}
                  </ul>
                )}
              </div>

              {i.action && <a href="">Ändra</a>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummarySection;
